import React from 'react';
import {
  HStack, VStack, Text, Icon, useToken,
} from '@gluestack-ui/themed';
import { Lock } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

// Helper function to generate unlock requirement message
const getUnlockRequirementsMessage = (task, allTasks, module) => {
  const levelOrder = module?.metadata?.levels?.map((level) => level.id) || [];
  const currentTaskLevelIndex = levelOrder.indexOf(task.level);

  const requiredTasks = allTasks?.filter((t) => {
    if (t.id === task.id) return false;
    const taskLevelIndex = levelOrder.indexOf(t.level);
    if (taskLevelIndex < currentTaskLevelIndex) return true;
    if (taskLevelIndex === currentTaskLevelIndex && t.sortIndex < task.sortIndex) return true;
    return false;
  }) || [];

  const incompleteTasks = requiredTasks.filter((t) => t.submission?.state !== 'marked_as_done');

  if (incompleteTasks.length === 0) {
    return 'All previous tasks are complete - this task should be unlocked soon';
  }

  if (incompleteTasks.length === 1) {
    return `Complete "${incompleteTasks[0].title}" to unlock`;
  }

  const taskNames = incompleteTasks.slice(0, 3).map((t) => t.title);
  if (incompleteTasks.length <= 3) {
    return `Complete these tasks to unlock: ${taskNames.join(', ')}`;
  }
  return `Complete these tasks to unlock: ${taskNames.join(', ')} and ${incompleteTasks.length - 3} more`;
};

const EventTaskLockedNotice = ({ task, tasks, module }) => {
  const { t } = useTranslation();
  const lockIconColor = useToken('colors', 'textLight400');
  const isOralExam = task?.type === 'oral_exam';

  if (isOralExam) {
    return (
      <HStack
        alignItems="center"
        space="sm"
        p="$3"
        bg="$backgroundLight50"
        borderRadius="$md"
        testID="oral-exam-registration-locked"
      >
        <Icon as={Lock} size="lg" color={lockIconColor} m="$2" />
        <VStack flex={1}>
          <Text size="sm" color="$textBody">
            {t('student.eventTask.registrationLockedMessage')}
          </Text>
        </VStack>
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" space="sm" p="$3" bg="$backgroundLight50" borderRadius="$md">
      <Icon as={Lock} size="lg" color={lockIconColor} m="$2" />
      <VStack flex={1}>
        <Text size="sm" color="$textBody" fontWeight="bold">
          {t('student.module.eventTask.states.locked')}
        </Text>
        <Text size="sm" color="$textSubtle" mt="$1">
          {getUnlockRequirementsMessage(task, tasks, module)}
        </Text>
      </VStack>
    </HStack>
  );
};

export default EventTaskLockedNotice;
